import { render } from "./NameAndText.vue?vue&type=template&id=cdd31672"
import script from "./NameAndText.vue?vue&type=script&lang=js"
export * from "./NameAndText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__